module.exports = __webpack_public_path__ + "static/img/9400_phase_function_Paper_PointsHejduk_Prediction.d89f877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/9400_phase_function_Paper_PointsHejduk_Prediction.png
// module id = r1LG
// module chunks = 0